import { Box, TextField, Typography } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";

import { Link } from "react-router-dom";
import { AuthConsumer, useAuth } from "../../context/AuthContext";

import { ToastContainer } from "react-toastify";
const ResetPassword = () => {
  //get current user, error and signUpNewUser method from useAuth
  const { resetPassword, error } = useAuth();

  // handleForm method
  const handleFormSubmit = (values) => {
    console.log(values);
    const email = values.email;
    // reset password method
    resetPassword(email);
  };

  return (
    <AuthConsumer>
      {() => {
        return (
          <section className="password-reset">
            <div className="container">
              <div>
                <Box
                  width={"100%"}
                  padding="7rem 12rem"
                  textAlign={"center !important"}
                  m="20px"
                  flexDirection={"column"}
                  alignContent={"center"}
                  justifyItems={"center"}
                  sx={{
                    transition: "0.8s all ease-in-out",
                  }}
                >
                  <h2 className="h2 mb-3 text-align-left text-primary">
                    Reset your password
                  </h2>
                  <p className="p-text mb-4 text-align-left">
                    Please enter your email to reset your password.
                  </p>
                  <Box className="pr-3">
                    <Formik
                      onSubmit={handleFormSubmit}
                      initialValues={initialValues}
                      validationSchema={checkoutSchema}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          <Box>
                            <TextField
                              placeholder="someone@company.com"
                              className="input-field"
                              fullWidth
                              variant="filled"
                              type="text"
                              label="Enter Your Email"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.email}
                              name="email"
                              error={!!touched.email && !!errors.email}
                              helperText={touched.email && errors.email}
                              sx={{ gridColumn: "span 4" }}
                            />
                          </Box>

                          <Box display="flex" justifyContent="center" mt="20px">
                            <button type="submit" className="btn w-100 center">
                              RESET PASSWORD
                            </button>
                          </Box>
                        </form>
                      )}
                    </Formik>
                  </Box>
                </Box>
              </div>

              {/* toast container to display toast */}
              <Box
                color={"InfoText"}
                marginTop={"4rem"}
                sx={{
                  "$ .toast-container": {
                    width: "10rem",
                    bgcolor: "grey",
                  },
                }}
              >
                <ToastContainer
                  className={"toast-container"}
                  position="top-center"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="dark"
                />
              </Box>
            </div>
          </section>
        );
      }}
    </AuthConsumer>
  );
};

const checkoutSchema = yup.object().shape({
  email: yup.string().email("invalid email").required("required"),
});
const initialValues = {
  email: "",
};

export default ResetPassword;
